<template>
  <p class="document-link text-uppercase">
    {{ filetype }} <span v-if="filesize !== ''">|</span> {{ filesize }}
  </p>
</template>

<script>
import helper from "../../mixins/swiper-helper";

export default {
  name: "document-link", // popular-related-articles
  props: ["url"],
  data() {
    return {
      filesize: "",
      filetype: "",
    };
  },
  created() {
    this.getsize();
  },
  methods: {
    async getsize() {
      this.filetype = this.url.split(".").pop();
      const size = await axios
        .head(this.url)
        .then((response) => {
          this.filesize =
            (response.headers["content-length"] / (1024 * 1024)).toFixed(2) +
            "MB";
        })
        .catch((error) => {
          console.log("Error in fetching the file!");
        });
    },
  },
};
</script>
